import styled from 'styled-components';

export const Wrapper = styled.div `
    padding-bottom: 160px;
    width: 700px;
    margin: auto;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 100px;
    justify-content: center;
    @media (max-width: 700px) {
        width: 100%;
    }
    @media (max-width: 700px) {
        gap: 80px;
    }
    .column-flex {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 0;
    }
    .main-title {
        font-weight: 700;
        font-size: 23px;
        color: black;
        @media (max-width: 600px) {
            font-size: 20px;
        }
    }
    .desc {
        font-weight: 400 !important;
        margin-top: -1px;
    }
    .contact-title, .about-title, .contact-desc {
        color: black;
        font-size: 19px;
        font-weight: 800;
        line-height: 38px;
        @media (max-width: 900px) {
            font-size: 18px;
            line-height: 36px;
        }
    }
    .about-title, contact-title {
        margin-bottom: -1px;
    }
    .about-desc, .desc {
        color: black;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 32px;
        @media (max-width: 900px) {
            font-size: 15px;
            line-height: 30px;
        }
    }
    .call-info {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        background: #20B79D;
        border-radius: 16px;
    }
    .contact-title {
        text-align: center;
        width: 100%;
    }
    .contact-desc {
        color: white;
    }
    .icon {
        color: white;
        width: 25px;
        height: 25px;
    }
`

export const AboutItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 180px;
    width: 200px;
    background: #fff;
    border-radius: 24px;
    padding: 25px 16px;
    gap: 10px;
    .desc {
        text-align: center;
        color: black;
        font-size: 15px;
        font-weight: 500;
        line-height: 30px;
        @media (max-width: 900px) {
            font-size: 14px;
            line-height: 28px;
        }
    }
    .img {
        height: 60px;
    }
`